<template>
    <form @submit.prevent="save" v-if="ShowForm" class="MailingListForm">

        <div v-if="Error" class="alert alert-danger" v-html="Error"></div>

        <div class="row">
            <div class="col-12 col-md-6">
                <fg-input type="text" label="Name" placeholder="Name" v-model:value="formInputs.name"></fg-input>
            </div>
            <div class="col-12 col-md-6">
                <fg-input type="email" label="Email" placeholder="Email" v-model:value="formInputs.email"></fg-input>
            </div>
        </div>

        <div class="row">
            <div class="col-12 text-center">
                <button class="btn btn-primary">Notify Me</button>
            </div>
        </div>

    </form>
    <div v-else>
        <p>Thank you for your interest. You will be notified when the site is about to be launched.</p>
    </div>
</template>
<script>
import apiMLE from '@/Modules/MailingLists/api/mailing_list_emails';

let FormInputs = () => {
    return {
        mailinglists_id: 0,
        name: '',
        email: ''
    };
};

export default {
    data() {
        return {
            formInputs: FormInputs(),
            Error: '',
            ShowForm: true
        };
    },
    props: {
        ListID: {
            type: Number,
            default: 1
        }
    },
    computed: {
    },
    mounted() {
        this.SetFormInputs();
    },
    methods: {
        SetFormInputs() {
            this.Error = '';
            this.formInputs = FormInputs();
            this.formInputs.mailinglists_id = this.ListID;
        },
        save() {
            this.Error = '';
                apiMLE.Add(this.formInputs).then(res => {
                    console.log({res});
                    this.formInputs = FormInputs();
                    this.ShowForm = false;
                }).catch(e => {
                    console.log('Error: ', e.response.data);
                    this.processErrors(e.response.data.errors, e.response.status);
                });
        },
        processErrors(Errors, Status) {
            let i = 0;
            if (Status === 422)
            {
                for (let x in Errors)
                {
                    this.Error += (i?'<br>':'')+Errors[x].join('<br>');
                    i++;
                }
            }
        }
    }
};
</script>
<style lang="scss">
.MailingListForm {
    label { display: block; text-align: left; }
    .has-success .form-control { border-color: #F96332; }
    .form-control { font-weight: bold; color: #F96332; background-color: transparent; }
    .form-control:focus { color: #F96332; background-color: transparent; }
    .has-success:after, .has-danger:after { top: 39.5px; right: 10px; bottom: 10px; }
}
</style>